import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectField from "../components/common/form/SelectField";
import { getTowns } from "../store/towns";
import { validator } from "../utils/validator";
import { getCurrentGroup } from "../store/groups";
import { getCurrentUserData, updateUser } from "../store/users";
import { useI18n } from "../i18n/LanguageContext";

function SelectTown(props) {
  const dispatch = useDispatch();
  const { t } = useI18n();
  const currentUser = useSelector(getCurrentUserData());
  const group = useSelector(getCurrentGroup());

  const towns = useSelector(getTowns());

  const [errors, setErrors] = useState({});

  const [data, setData] = useState();

  useEffect(() => {
    if (group !== undefined) {
      setData({ town: currentUser?.town });
    }
  }, [currentUser, group]);

  const setSelectTown = (arr) => {
    return arr.map((elem) => ({ value: elem._id, label: elem.name }));
  };

  const handleChange = (target) => {
    setData((prevState) => ({
      ...prevState,
      [target.name]: target.value,
    }));
  };

  const validatorConfig = useMemo(
    () => ({
      town: {
        isRequireTown: {
          message: t("register.err.town"),
        },
        isTownNeed: {
          message: t("register.town"),
          value: "" || "Choose...",
        },
        isNotRepeat: {
          message: t("town.other"),
          value: currentUser && currentUser.town,
        },
      },
      missionId: {
        isCheckMission: {
          message: t("town.inGame"),
          value: "",
        },
      },
    }),
    [currentUser, t]
  );

  useEffect(() => {
    validate();
  }, [data]);

  const validate = useCallback(() => {
    const errors = validator(data, validatorConfig);
    setErrors(errors);
    return Object.keys(errors).length === 0;
  }, [data, validatorConfig]);

  const isValid = Object.keys(errors).length === 0;

  const handleSet = () => {
    dispatch(updateUser({ ...currentUser, town: data.town }));
  };

  return (
    <div className="container w-full flex justify-center my-10 mx-auto">
      <div className="w-full mx-auto sm:mx-10">
        <SelectField
          label={t("user.changeCity")}
          defaultOption={t("register.choose")}
          options={setSelectTown(towns)}
          name="town"
          onChange={handleChange}
          value={data?.town}
          error={errors.town}
        />
        {!isValid && (
          <button
            onClick={handleSet}
            className="my-5 px-5 py-2 rounded bg-green-400 mr-5 hover:bg-green-500"
            disabled={!isValid ? true : false}
          >
            {t("user.change")}
          </button>
        )}
      </div>
    </div>
  );
}

SelectTown.propTypes = {};

export default SelectTown;
